"use client";

import * as React from "react";
import { $createParagraphNode, $getRoot, $isParagraphNode } from "lexical";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";

export function InitialFocusPlugin({ isEditable }: { isEditable: boolean }) {
  const [editor] = useLexicalComposerContext();
  const didInitRef = React.useRef(false);

  React.useEffect(() => {
    if (!isEditable) return;
    if (didInitRef.current) return;
    didInitRef.current = true;

    editor.update(() => {
      const root = $getRoot();
      const children = root.getChildren();
      const first = children[0];

      if (!first) {
        root.append($createParagraphNode());
        const next = root.getChildren()[0];
        if (next && $isParagraphNode(next)) (next as any).selectStart?.();
        return;
      }

      // 进入编辑页时选区落在文档开头（首块起始），而非文末
      const firstEl = first as { selectStart?: () => void };
      firstEl.selectStart?.();
    });

    editor.focus();
  }, [editor, isEditable]);

  return null;
}

